import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ChargeRowActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  flexShrink: 0,
});
